const getDescriptionUrlById = (webhooks: any[], id: string) => {
  const item = webhooks.find((hook: { id: string }) => hook.id === id);
  return item?.descriptionUrl || null;
};
export default getDescriptionUrlById;
